import { makeAutoObservable } from 'mobx'
import { type ISchedulePeriod, SchedulePeriodStore } from 'shared/ui/Schedule/ui/SchedulePeriod'

export type IInitScheduleDelayStoreProps = { unit: ISchedulePeriod; value: string }

export class ScheduleDelayStore {
  schedulePeriodStore
  constructor(params?: IInitScheduleDelayStoreProps) {
    this.schedulePeriodStore = new SchedulePeriodStore()
    if (params) {
      this.init(params)
    }
    makeAutoObservable(this)
  }

  get params() {
    return {
      unit: this.schedulePeriodStore.period,
      value: this.waitValue,
    }
  }

  get scheduleText() {
    return `${this.params.value} ${this.params.unit}`
  }

  init = ({ unit, value }: IInitScheduleDelayStoreProps) => {
    this.schedulePeriodStore.setPeriod(unit)
    this.waitValue = value
  }

  waitValue = '30'
  lastValidValue = '30'
  setLastValidValue = (value: string) => {
    this.lastValidValue = value
  }
  setWaitValue = (value: string) => {
    this.waitValue = value
  }
  handleValidate = () => {
    if (!Number(this.waitValue)) {
      this.setWaitValue(this.lastValidValue)
    }
  }
}
